// Vapi Web SDK wrapper — exposes window.VapiWeb for browser voice sessions.
// Imported from application.js so the SDK is bundled once and shared.

import Vapi from '@vapi-ai/web'

let _vapi = null

const VapiWeb = {
  // webCallUrl + callId come from the server-created call (/call/web).
  // We use reconnect() — not start() — because start() creates a brand-new call
  // client-side and requires passing an assistant config, while reconnect() joins
  // an already-created call using the Daily.co room URL that Vapi returned.
  async start (webCallUrl, callId, { onStart, onEnd, onSpeechStart, onSpeechEnd, onToolCall, onError } = {}) {
    if (_vapi) this.stop()

    // API key is not used for reconnect — the call was already authenticated server-side.
    _vapi = new Vapi('')

    _vapi.on('call-start', () => { if (onStart) onStart() })

    _vapi.on('call-end', () => {
      if (onEnd) onEnd()
      _vapi = null
    })

    _vapi.on('speech-start', () => { if (onSpeechStart) onSpeechStart() })
    _vapi.on('speech-end', () => { if (onSpeechEnd) onSpeechEnd() })

    _vapi.on('message', (msg) => {
      // Tool calls arrive as type 'tool-calls' with a toolCallList array.
      // arguments is a JSON string per the SDK types — parse defensively.
      if (msg.type === 'tool-calls' && msg.toolCallList) {
        msg.toolCallList.forEach(tc => {
          let args = tc.function.arguments
          if (typeof args === 'string') {
            try { args = JSON.parse(args) } catch (_) { args = {} }
          }
          // Pass toolCallId so handlers can send results back to the model
          if (onToolCall) onToolCall(tc.function.name, args || {}, tc.id)
        })
      }
    })

    _vapi.on('error', (err) => {
      console.error('[VapiWeb]', err)
      if (onError) onError(err)
    })

    try {
      await _vapi.reconnect({ webCallUrl, id: callId })
    } catch (err) {
      console.error('[VapiWeb] reconnect failed', err)
      _vapi = null
      if (onError) onError(err)
    }
  },

  stop () {
    if (_vapi) {
      try { _vapi.stop() } catch (_) {}
      _vapi = null
    }
  },

  // Send a tool result back to the model so it can continue the conversation
  sendToolResult (toolCallId, content) {
    if (_vapi && toolCallId) {
      try {
        _vapi.send({
          type: 'add-message',
          message: { role: 'tool', toolCallId, content: String(content) }
        })
      } catch (e) {
        console.warn('[VapiWeb] sendToolResult failed', e)
      }
    }
  },

  setMuted (muted) { if (_vapi) _vapi.setMuted(muted) },
  isMuted () { return _vapi ? _vapi.isMuted() : false },
  isActive () { return !!_vapi }
}

window.VapiWeb = VapiWeb
export default VapiWeb
